"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Alert.css");
var icons_1 = require("@tiendanube/icons");
var Button_1 = __importDefault(require("../Button"));
var Link_1 = __importDefault(require("../Link"));
var Title_1 = __importDefault(require("../Title"));
var Text_1 = __importDefault(require("../Text"));
function Alert(_a) {
    var children = _a.children, _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, title = _a.title, primaryLabel = _a.primaryLabel, onClickPrimary = _a.onClickPrimary, secondaryLabel = _a.secondaryLabel, secondaryTo = _a.secondaryTo, onDismiss = _a.onDismiss, _c = _a.show, show = _c === void 0 ? false : _c;
    var memorizedIcon = React.useMemo(function () {
        var iconVariants = {
            primary: icons_1.InfoCircleIcon,
            secondary: icons_1.InfoCircleIcon,
            danger: icons_1.ExclamationTriangleIcon,
            success: icons_1.CheckCircleIcon,
            warning: icons_1.ExclamationCircleIcon,
        };
        var Icon = iconVariants[appearance];
        return React.createElement(Icon, null);
    }, [appearance]);
    var memorizedPrimary = React.useMemo(function () {
        return primaryLabel &&
            onClickPrimary && (React.createElement(Button_1.default, { onClick: onClickPrimary, appearance: "secondary" }, primaryLabel));
    }, [primaryLabel, onClickPrimary]);
    var memorizedSecondary = React.useMemo(function () {
        return secondaryLabel &&
            secondaryTo && (React.createElement(Link_1.default, { size: "small", href: secondaryTo }, secondaryLabel));
    }, [secondaryLabel, secondaryTo]);
    var memorizedDismissable = React.useMemo(function () {
        return onDismiss && (React.createElement("button", { type: "button", "aria-label": "Close", className: "nimbus--alert__close", onClick: onDismiss },
            React.createElement(icons_1.CloseIcon, null)));
    }, [onDismiss]);
    var withActions = (primaryLabel || secondaryLabel) && (React.createElement("div", { className: "nimbus--alert__actions" },
        memorizedPrimary,
        memorizedSecondary));
    var classname = React.useMemo(function () {
        return "nimbus--alert nimbus--alert--".concat(appearance, " ").concat(onDismiss ? "is-dismissable" : "");
    }, [appearance, onDismiss]);
    var Children = typeof children === "string" ? (React.createElement(Text_1.default, { size: "base" }, children)) : (React.createElement(React.Fragment, null, children));
    return (React.createElement(React.Fragment, null, show && (React.createElement("div", { className: classname, role: "alert" },
        React.createElement("div", { className: "nimbus--alert__icon" }, memorizedIcon),
        React.createElement("div", { className: "nimbus--alert__details" },
            React.createElement("div", { className: "nimbus--alert__body" },
                title && React.createElement(Title_1.default, { type: "h6" }, title),
                React.createElement("div", { className: "nimbus--alert__body_children" }, Children)),
            withActions),
        memorizedDismissable))));
}
exports.default = Alert;
//# sourceMappingURL=index.js.map